module.exports = __webpack_public_path__ + "static/media/arrow_HistorialND.490415df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/arrow_HistorialND.svg
// module id = 1782
// module chunks = 0